<h3 mat-dialog-title>Email Sent</h3>
<mat-dialog-content >
    {{translateArr.bp1}}
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 30px;">
    <button mat-button mat-dialog-close (click)="OK()">{{translateArr.bp2}}</button>
</mat-dialog-actions>

